import React, { useRef, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import CalculatorComponent from "./CalculatorComponent";

export default function Calculator({ scaleVal }) {
  const screenRef = useRef();
  const [clearValuesTrigger, setClearValuesTrigger] = useState(false);

  const scaleFactor = 1.6;

  useEffect(() => {
    const rootElement = document.documentElement;
    const computedStyle = getComputedStyle(rootElement);
    const value = computedStyle.getPropertyValue("--fontmultiplier");

    if (value !== scaleFactor) {
      document.documentElement.style.setProperty(
        "--fontmultiplier",
        scaleFactor
      );
    }

    document.documentElement.style.setProperty("--background", "#17181d");
    document.documentElement.style.setProperty(
      "--overlayGradStart",
      "rgba(171, 142, 63, .7)"
    );
    document.documentElement.style.setProperty(
      "--overlayGradEnd",
      "rgba(171, 142, 63, 1)"
    );
    document.documentElement.style.setProperty(
      "--primary-font-color",
      "rgba(23, 24, 29, .8)"
    );
    document.documentElement.style.setProperty("--checkboxColor", "#ab8e3f");
    document.documentElement.style.setProperty("--rowBorderTopSize", "0px");
  });

  function clearValues() {
    setClearValuesTrigger(true);
  }

  return (
    <>
      <div className="outer-cont-sa standalone-calc-page">
        <div className={["page-container-sa"].join(" ")}>
          <CalculatorComponent
            scaleVal={scaleVal}
            screenRef={screenRef}
            clearValuesTrigger={clearValuesTrigger}
            setClearValuesTrigger={setClearValuesTrigger}
          />

          {/* <div className={["page-footer-sa"].join(" ")}> */}
            <div className={["page-footer", "mw-row"].join(" ")}>
            <Button
              className={["kmt-savings-button", "gold-button"].join(" ")}
              variant="secondary"
              onClick={clearValues}
            >
              Clear
            </Button>
            <div />
          </div>
        </div>
      </div>
    </>
  );
}
